module.exports = __webpack_public_path__ + "img/undraw_interview_rmcf.f9025adf.svg";